import { combineReducers } from 'redux';
import type { Query } from '../query-param-adapter/model';
import analyticsData, { type AnalyticsDataState } from './analytics/reducer';
import components, { type ComponentsState } from './components/reducer';
import context, { type ContextState } from './context/reducer';
import project, { type ProjectState } from './project/reducer';
import query from './query/reducer';
import ui, { type UiState } from './ui/reducer';

export type State = {
	readonly components: ComponentsState;
	readonly project: ProjectState;
	readonly ui: UiState;
	readonly context: ContextState;
	readonly analyticsData: AnalyticsDataState;
	readonly query: Query;
};

const combinedReducer = combineReducers({
	components,
	project,
	ui,
	context,
	analyticsData,
	query,
});

export default combinedReducer;
